/**
 * Used for migration as the model can not be determined from the
 * visual model alone in version 0.
 */
export const UNKNOWN_MODEL = "unknown-model";
/**
 * Used for migration as the visual entity can not be determined from the
 * visual model alone in version 0.
 */
export const UNKNOWN_ENTITY = "unknown-entity";
export const VISUAL_NODE_TYPE = "visual-node";
export function isVisualNode(what) {
    return what.type.includes(VISUAL_NODE_TYPE);
}
export const VISUAL_DIAGRAM_NODE_TYPE = "visual-diagram-node";
export function isVisualDiagramNode(what) {
    return what.type.includes(VISUAL_DIAGRAM_NODE_TYPE);
}
;
export const VISUAL_RELATIONSHIP_TYPE = "visual-relationship";
export function isVisualRelationship(what) {
    return what.type.includes(VISUAL_RELATIONSHIP_TYPE);
}
export const VISUAL_PROFILE_RELATIONSHIP_TYPE = "visual-profile-relationship";
export function isVisualProfileRelationship(what) {
    return what.type.includes(VISUAL_PROFILE_RELATIONSHIP_TYPE);
}
export const VISUAL_GROUP_TYPE = "visual-group";
export function isVisualGroup(what) {
    return what.type.includes(VISUAL_GROUP_TYPE);
}
export const MODEL_VISUAL_TYPE = "http://dataspecer.com/resources/local/visual-model";
export function isModelVisualInformation(what) {
    return what.type.includes(MODEL_VISUAL_TYPE);
}
export const VISUAL_VIEW_TYPE = "visual-view";
export function isVisualView(what) {
    return what.type.includes(VISUAL_VIEW_TYPE);
}
//# sourceMappingURL=visual-entity.js.map